import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ProgramEntity } from "../../services/programs/programs.types";

export type ProgramState = {
  programs: ProgramEntity[];
  loading: boolean;
};

const initialState: ProgramState = {
  programs: [],
  loading: false,
};

const program = createSlice({
  name: "program",
  initialState,
  reducers: {
    clearProgram: (state) => {
      state.programs = [];
      state.loading = false;
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
    setPrograms: (state, action: PayloadAction<ProgramEntity[]>) => {
      state.programs = action.payload;
      state.loading = false;
    },
    addProgram: (state, action: PayloadAction<ProgramEntity>) => {
      state.programs.unshift(action.payload);
    },
    updateProgram: (
      state,
      action: PayloadAction<{ id: number; data: ProgramEntity }>
    ) => {
      const index = state.programs.findIndex(
        (program) => program.id === action.payload.id
      );
      if (index !== -1) {
        state.programs[index] = action.payload.data;
      }
    },
    deleteProgram: (state, action: PayloadAction<number>) => {
      state.programs = state.programs.filter(
        (program) => program.id !== action.payload
      );
    },
  },
});

export default program;
export const {
  addProgram,
  clearProgram,
  deleteProgram,
  setPrograms,
  setLoading,
  updateProgram,
} = program.actions;
